import {
  GET_PROCESS,
  SET_LOADING_PROCESS,
  PROCESS_ERROR,
  CLEAR_DATA_PROCESS,
} from '../types';

export default (state, action) => {
  switch (action.type) {
    case GET_PROCESS:
      return {
        ...state,
        process: action.payload,
        loading: false,
        errors: null,
      };
    case SET_LOADING_PROCESS:
      return {
        ...state,
        loading: true,
      };
    case PROCESS_ERROR:
      return {
        ...state,
        errors: action.payload,
        loading: false,
      };
    case CLEAR_DATA_PROCESS:
      return {
        ...state,
        process: {},
        loading: false,
        errors: null,
      };
    default:
      return state;
  }
};
